import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const UgcSubForm = loadable(() => withDefaultLoaderModifiers(import("./UgcSubForm")));
